import {
  useParams,
  Navigate,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import styles from './PaymentPage.module.css';
import W_PaymentSubscribePlanContent from '../../components/W_Wrappers/W_PaymentSubscribePlanContent/W_PaymentSubscribePlanContent';
import W_PaymentTreeDonateContent from '../../components/W_Wrappers/W_PaymentTreeDonateContent/W_PaymentTreeDonateContent';
import W_PaymentScenarioPurchaseContent from '../../components/W_Wrappers/W_PaymentScenarioPurchaseContent/W_PaymentScenarioPurchaseContent';
import { useTree } from '../../contexts/TreeContext';
import A_CircleButton from '../../components/A_Atoms/A_CircleButton/A_CircleButton';
import { Q_Icon } from '../../components/Q_Quarks/Q_Icon/Q_Icon';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslation } from '../../constants/translations';
import cn from 'classnames';
import Q_BlurEffect from '@/components/Q_Quarks/Q_BlurEffect/Q_BlurEffect';

export default function PaymentPage() {
  const { treeId, capsuleId } = useParams<{
    treeId: string;
    capsuleId?: string;
  }>();
  const [searchParams] = useSearchParams();
  const { getTreeById } = useTree();
  const navigate = useNavigate();
  const isSubscriptionPayment = window.location.pathname.includes(
    '/payment/subscription'
  );
  const isCapsuleDonationPayment =
    !!treeId && !!capsuleId && window.location.pathname.includes('/capsule/');
  const isScenarioPurchase = !!searchParams.get('scenarioId');
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const tree = treeId ? getTreeById(treeId) : null;
  const titleText = isCapsuleDonationPayment
    ? t('payment.title.treeDonation')
    : isSubscriptionPayment
      ? t('payment.title.subscription')
      : t('payment.title.scenarioPurchase');

  if (isCapsuleDonationPayment && !tree) {
    return <Navigate to='/tree' replace />;
  }

  return (
    <>
      <div className={styles.header}>
        <A_CircleButton
          icon={
            <Q_Icon.ArrowLeftIcon
              width={14}
              height={27}
              fill='none'
              stroke='currentColor'
            />
          }
          onClick={() => navigate(-1)}
          variant='secondary'
        />
        <div className={styles.title_wrapper}>
          <p className={cn(styles.title, 'text-p-4')}>{titleText}</p>
        </div>
        <div className={styles.blur_wrapper}>
          <Q_BlurEffect yAxis='top' />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.back_button_wrapper}>
          <A_CircleButton
            icon={
              <Q_Icon.ArrowLeftIcon
                width={14}
                height={27}
                fill='none'
                stroke='currentColor'
              />
            }
            onClick={() => navigate(-1)}
            variant='secondary'
          />
        </div>
        {isSubscriptionPayment && <W_PaymentSubscribePlanContent />}

        {isCapsuleDonationPayment && tree && (
          <W_PaymentTreeDonateContent
            progress={Math.round((tree.totalDonations / tree.cost) * 100)}
            totalDonations={tree.totalDonations}
            cost={tree.cost}
            name={tree.name}
            donorsCount={tree.donorsCount || 0}
          />
        )}

        {isScenarioPurchase && <W_PaymentScenarioPurchaseContent />}

        {!isSubscriptionPayment &&
          !isCapsuleDonationPayment &&
          !isScenarioPurchase && <W_PaymentSubscribePlanContent />}
      </div>
    </>
  );
}
